import { useEffect, useRef } from "react";

// The socket becomes available after authentication and can change on account switches.
export default function useLiveMessages({ socket, companyId, ticketId, onCreate, onUpdate, onDelete }) {
  const handlers = useRef({ onCreate, onUpdate, onDelete });
  handlers.current = { onCreate, onUpdate, onDelete };

  useEffect(() => {
    if (!socket?.on || !companyId || !ticketId || ticketId === "undefined") return;
    const room = String(ticketId);
    const event = `company-${companyId}-appMessage`;
    const join = () => socket.emit("joinChatBox", room);
    const onMessage = (data) => {
      const ticket = data?.ticket || data?.message?.ticket;
      if (String(ticket?.uuid ?? ticket?.id) !== room) return;
      if (data.action === "create" && data.message) handlers.current.onCreate?.(data.message);
      if (data.action === "update" && data.message) handlers.current.onUpdate?.(data.message);
      if (data.action === "delete") handlers.current.onDelete?.(data.messageId ?? data.message?.id);
    };

    socket.on("connect", join);
    socket.on(event, onMessage);
    // A conversation can open after the connection's initial "connect" event.
    join();
    return () => {
      socket.emit("joinChatBoxLeave", room);
      socket.off("connect", join);
      socket.off(event, onMessage);
    };
  }, [socket, companyId, ticketId]);
}
